module.exports = __webpack_public_path__ + "img/pasta_sliced.14285db3.jpg";